// eslint-disable-next-line
const goToBrand = url => (window.location = url);

module.exports = goToBrand;
